import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useUpdateEffect } from '~shared/hooks/useUpdateEffect';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from 'react-error-boundary';

import { getThemeClass } from '~spa/Utils/Skins';

import heroImage from './backboard.jpg';
import './styles.scss';

const ErrorMessage = ({ resetErrorBoundary }) => {
    const [ t ] = useTranslation();
    const { pathname: currentUrlPath } = useLocation();
    const theme = getThemeClass(1);

    useUpdateEffect(() => {
        resetErrorBoundary();
    }, [currentUrlPath]);

    const classes = classNames(
        'CrashDetector',
        theme
    );

    return (
        <div className={classes} data-spectate-product="spectateClient;errorBoundary">
            <img
                className="CrashDetector__heroImage"
                src={heroImage}
                alt={t('error.crash_message')}
            />
            <p className="CrashDetector__message">
                {t('error.crash_message')}
            </p>
            <a className="CrashDetector__reset" onClick={resetErrorBoundary}>
                {t('error.crash_cta')}
            </a>
        </div>
    );
};

ErrorMessage.propTypes = {
    resetErrorBoundary: PropTypes.func.isRequired,
};

const CrashDetector = ({children}) => {
    return (
        <ErrorBoundary
            FallbackComponent={ErrorMessage}
        >
            {children}
        </ErrorBoundary>
    );
};

CrashDetector.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CrashDetector;
